export default __webpack_public_path__ + "static/media/favicon.29a0657b.gif";